import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import AppAlert from '@/components/common/AppAlert.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMapMarkerAlt, faPhoneAlt, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons'
import { faWeixin, faWeibo, faQq } from '@fortawesome/free-brands-svg-icons'

library.add(faMapMarkerAlt, faPhoneAlt, faEnvelope, faClock, faWeixin, faWeibo, faQq)

// 创建Vue应用实例
const app = createApp(App)

// 注册全局组件
// import GlobalComponent from './components/GlobalComponent.vue'
// app.component('GlobalComponent', GlobalComponent)

// 使用插件
app.use(router)
app.use(store)
app.use(ElementPlus)

// 初始化时获取用户信息
if (store.state.user.token) {
  try {
    store.dispatch('user/fetchUser')
  } catch (error) {
    console.log('自动登录失败，跳转到登录页面')
    router.push('/login')
  }
}

// 挂载应用
app.component('AppAlert', AppAlert)
app.mount('#app') 